import { IDatasource } from 'core-ts-types';
import { IInterface, IInterfaceDTD } from 'utility-js-interface';

export interface IPollStudentBuilderDTD {
  is_anonymous: boolean;
  is_completed: boolean;
}

export class PollStudentDataStore implements IDatasource {
  id: string;
  store: IPollStudentBuilderDTD;

  constructor() {
    this.id = 'poll_student';
    this.store = {} as IPollStudentBuilderDTD;
  }

  write(data: IPollStudentBuilderDTD): PollStudentDataStore {
    this.store = data;
    return this;
  }

  initialize(): PollStudentDataStore {
    this.store = {
      is_anonymous: false,
      is_completed: false
    } as IPollStudentBuilderDTD;
    return this;
  }

  read(): IPollStudentBuilderDTD {
    return this.store;
  }

  report(fn: (store: IPollStudentBuilderDTD) => any): any {
    return fn(this.store);
  }
}

angular.module('capability-ng-poll').factory('ngPollStudentDataStore', (): PollStudentDataStore => {
  return new PollStudentDataStore().initialize();
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/datastore/poll_student_datastore.ts